<template>
  <div>
    <!-- 绩效指标确定 -->
    <Table
      border
      ref="selection"
      :loading="loading"
      :columns="columns"
      :data="data"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          icon="ios-list-box"
          size="small"
          style="margin-right: 8px"
          @click="openBtn(row, index)"
          >查看</Button
        >
      </template>
      <template slot-scope="{ row, index }" slot="action1">
        <Button
          type="warning"
          icon="md-create"
          size="small"
          @click="editBtn(row, index)"
          >编辑</Button
        >
        <Button
          type="error"
          icon="md-trash"
          size="small"
          @click="deletBtn(row, index)"
          >删除</Button
        >
      </template>
    </Table>
    <div style="display: flex; justify-content: flex-end">
      <Button style="margin:10px 0" @click="addData" :disabled="loading"
        >新增</Button
      >
    </div>

    <Modal
      v-model="showSetting"
      :title="action == 1 ? '新增' : '编辑'"
      width="500px"
    >
      <div class="center" style="padding: 0 40px;">
        <Form :label-width="140" label-position="left">
          <FormItem label="年度">
            <Input v-model="formItem.year" />
          </FormItem>
          <FormItem label="可用状态">
            <Select v-model="formItem.status" :clearable="true" placeholder="">
              <Option
                v-for="item in effectiveList"
                :key="item.code"
                :value="item.code"
                >{{ item.name1 }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="绩效类型">
            <Select
              v-model="formItem.achTypeId"
              :clearable="true"
              placeholder=""
            >
              <Option
                v-for="item in achTypeList"
                :key="item.id"
                :value="item.id"
                >{{ item.evaCode }}</Option
              >
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="saveScore">保存</Button>
      </div>
    </Modal>
    <div v-show="openTable">
      <FormTitle titleText="查看" />
      <Table
        border
        ref="Table"
        id="Table"
        :loading="loading"
        :columns="columns1"
        :data="data1"
      >
        <template slot-scope="{ row, index }" slot="action2">
          <Button
            icon="md-create"
            type="warning"
            size="small"
            style="margin-right: 8px"
            @click="editData(row, index)"
            >编辑</Button
          >
          <Button
            icon="md-trash"
            type="error"
            size="small"
            @click="deletedData(index)"
            >删除</Button
          >
        </template>
      </Table>
      <div style="display: flex; justify-content: flex-end">
        <Button
          style="margin:10px 0 10px 15px"
          :disabled="loading"
          @click="handelFile"
          >导入</Button
        >
        <input
          type="file"
          ref="uploadExcel"
          accept=".xlsx,.xls"
          id="excel-file"
          @change="importExcel"
          v-show="false"
        />
        <Button
          style="margin:10px 0 10px 15px"
          :disabled="loading"
          @click="addBtn"
          >新增</Button
        >
        <Button
          style="margin:10px 0 10px 15px"
          :disabled="loading"
          @click="saveData"
          >保存</Button
        >
        <Button
          style="margin:10px 0 10px 15px"
          :disabled="loading"
          @click="closeTable"
          >关闭</Button
        >
      </div>
    </div>
    <Modal
      v-model="openEdit"
      :title="slotAction == 1 ? '新增' : '编辑'"
      width="500px"
    >
      <div class="center" style="padding: 0 40px;">
        <Form :label-width="140" label-position="left">
          <FormItem label="年度">
            <Input v-model="performanceItem.year" disabled />
          </FormItem>
          <FormItem label="职位">
            <Input v-model="performanceItem.position" />
          </FormItem>
          <FormItem label="部门">
            <Input v-model="performanceItem.department" />
          </FormItem>
          <FormItem label="评价类型">
            <Select
              v-model="performanceItem.evaType"
              :clearable="true"
              placeholder=""
            >
              <Option
                v-for="item in evaTypeList"
                :key="item.code"
                :value="item.code"
                >{{ item.value }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="指标Code">
            <Input v-model="performanceItem.commonCode" />
          </FormItem>
          <FormItem label="指标维度">
            <Input v-model="performanceItem.commonDimension" />
          </FormItem>
          <FormItem label="指标项">
            <Input v-model="performanceItem.commonItem" />
          </FormItem>
          <FormItem label="内容概述">
            <Input v-model="performanceItem.content" />
          </FormItem>
          <FormItem label="目标值">
            <Input v-model="performanceItem.target" />
          </FormItem>
          <FormItem label="权重">
            <Input v-model="performanceItem.weight" />
            <span class="weight-style">%</span>
          </FormItem>
          <FormItem label="评分方法">
            <Input v-model="performanceItem.method" />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="confirmSave">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
import formTitle from "../../formPageComponents/formTitle.vue";
export default {
  components: { formTitle },
  data() {
    return {
      columns: [
        {
          title: "版本",
          key: "banben",
          align: "center",
          minWidth: 120
        },
        {
          title: "年度",
          key: "year",
          align: "center",
          minWidth: 120
        },
        {
          title: "可用状态",
          key: "status",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            var name = "";
            this.effectiveList
              ? this.effectiveList.map(item => {
                  if (item.code == params.row.status) {
                    name = item.name1;
                  }
                })
              : "";
            return h("span", name);
          }
        },
        {
          title: "绩效类型",
          key: "achTypeId",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            var name = "";
            this.achTypeList
              ? this.achTypeList.map(item => {
                  if (item.id == params.row.achTypeId) {
                    name = item.evaCode;
                  }
                })
              : "";
            return h("span", name);
          }
        },
        {
          title: "查看",
          slot: "action",
          align: "center",
          minWidth: 120
        },
        {
          title: "编辑",
          slot: "action1",
          align: "center",
          minWidth: 200
        }
      ],
      data: [
        {
          banben: "1",
          year: "2021",
          status: "1",
          achTypeId: "1"
        }
      ],
      columns1: [
        {
          title: "年度",
          key: "year",
          align: "center",
          minWidth: 120
        },
        {
          title: "职位",
          key: "position",
          align: "center",
          minWidth: 120
        },
        {
          title: "部门",
          key: "department",
          align: "center",
          minWidth: 120
        },
        {
          title: "评价类型",
          key: "evaType",
          align: "center",
          minWidth: 120
        },
        {
          title: "指标Code",
          key: "commonCode",
          align: "center",
          minWidth: 120
        },
        {
          title: "指标维度",
          key: "commonDimension",
          align: "center",
          minWidth: 120
        },
        {
          title: "指标项",
          key: "commonItem",
          align: "center",
          minWidth: 120
        },
        {
          title: "内容概述",
          key: "content",
          align: "center",
          minWidth: 120
        },
        {
          title: "目标值",
          key: "target",
          align: "center",
          minWidth: 120
        },
        {
          title: "权重",
          key: "weight",
          align: "center",
          minWidth: 120
        },
        {
          title: "评分方法",
          key: "method",
          align: "center",
          minWidth: 120
        },
        {
          title: "编辑",
          slot: "action2",
          align: "center",
          minWidth: 200
        }
      ],
      data1: [],
      formItem: {},
      performanceItem: {},
      showSetting: false,
      loading: false,
      openTable: false,
      achTypeList: [],
      effectiveList: [],
      evaTypeList: [],
      action: 0,
      slotAction: 0,
      openEdit: false,
      index: 0,
      row: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      axios.post("/AchCommonSet/selectAchCommonSet", {}).then(res => {
        this.loading = false;
        this.data = res.achCommonSetList;
        this.data.forEach((item, index) => {
          item.banben = index + 1;
        });
        this.achTypeList = res.achTypeList;
        this.effectiveList = res.effectiveList;
      });
    },

    addData() {
      this.showSetting = true;
      this.action = 1;
      this.formItem = {};
    },
    editBtn(row, index) {
      this.showSetting = true;
      this.action = 2;
      this.formItem = { ...row };
    },
    saveScore() {
      this.loading = true;
      let obj = {
        ...this.formItem,
        createUserId:
          this.action == 1
            ? JSON.parse(sessionStorage.getItem("userInfo")).userId
            : null,
        updateUserId: JSON.parse(sessionStorage.getItem("userInfo")).userId
      };
      // 新增
      if (this.action == 1) {
        axios.post("/AchCommonSet/insertAchCommonSet", obj).then(res => {
          this.showSetting = false;
          this.loading = false;
        });
        // 编辑
      } else if (this.action == 2) {
        axios.post("/AchCommonSet/updateAchCommonSet", obj).then(res => {
          this.showSetting = false;
          this.loading = false;
        });
      }
      this.getData();
    },
    openBtn(row, index) {
      this.row = row;
      this.openTable = true;
      let obj = {
        id: this.row.id,
        achTypeId: row.achTypeId
      };
      this.loading = true;
      axios
        .post("/AchCommonSetDetails/selectAchCommonSetDetails", obj)
        .then(res => {
          this.loading = false;
          this.data1 = res.achCommonSetDetailsList;
          this.evaTypeList = res.evaTypeList;
        });
    },
    deletBtn(row, index) {
      this.$Modal.confirm({
        title: this.$notice("deletion"),
        content: "",
        onOk: () => {
          let obj = { ...row };
          this.loading = true;
          axios.post("/AchCommonSet/deleteAchCommonSet", obj).then(res => {
            this.getData();
            this.loading = false;
            this.openTable = false;
          });
        }
      });
    },
    deletedData(index) {
      this.data1.splice(index, 1);
    },
    closeTable() {
      this.openTable = false;
    },
    handelFile() {
      this.$refs.uploadExcel.click();
    },
    importExcel(e) {
      var file_name = document.getElementById("excel-file").value;
      file_name = file_name.substring(file_name.lastIndexOf(".")).toLowerCase();
      var uploadFormat = [".xlsx", ".xls"];
      if (file_name != uploadFormat[0] && file_name != uploadFormat[1]) {
        this.$Message.warning({
          content:
            "文件类型不正确, 请选择" + uploadFormat.join(" or ") + "类型",
          duration: 5
        });
        return;
      }
      this.loading = true;
      this.$importExcel("excel-file", e, "Table", data => {
        this.loading = false;
        this.data1 = this.data1.concat(data);
        axios.post("/AchEvaEmpSet/importAchEvaEmpSet", data).then(res => {
          this.prevent = false;
          if (res) {
            this.$Message.success("导入成功");
          }
        });
      });
    },
    addBtn() {
      this.openEdit = true;
      this.performanceItem = {};
      this.slotAction = 1;
      this.performanceItem.year = this.row.year;
    },
    editData(row, index) {
      this.openEdit = true;

      this.performanceItem = { ...row };
      console.log(row, "bianji");
      this.slotAction = 2;
      this.index = index;
    },
    deletedData(index) {
      this.data1.splice(index, 1);
    },
    confirmSave() {
      if (this.slotAction == 1) {
        this.data1.push(this.performanceItem);
      } else {
        this.data1.splice(this.index, 1, this.performanceItem);
      }
      this.openEdit = false;
    },
    saveData() {
      this.data1.forEach(item => {
        // 绩效类型
        item.achItemId = this.row.achTypeId;
      });
      let obj = {
        achCommonSetDetails: this.data1,
        id: this.row.id
      };
      this.loading = true;
      axios
        .post("/AchCommonSetDetails/saveAchCommonSetDetails", obj)
        .then(res => {
          this.loading = false;
          if (res) {
            this.$Message.success(this.$t("Save_Successful"));
          }
        });
    }
  }
};
</script>

<style scoped>
.weight-style {
  position: absolute;
  top: 0;
  right: 0;
  display: table-cell;
  white-space: nowrap;
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PerformanceIndicator.vue